import * as React from "react";
import { optionalKey } from "@grandvisionhq/utils";
import { createPriceSpecification } from "../../../actions/StructuredData/actions/helpers.js";
import { JsonLd } from "../../../StructuredData/JsonLd.js";
const Product = ({
  brand,
  category,
  description,
  extra,
  image,
  name,
  priceSpecificationConfig,
  ratingsSummary,
  sku,
  url,
  isCentAmount = true
}) => {
  const specification = priceSpecificationConfig && createPriceSpecification(priceSpecificationConfig, sku, isCentAmount);
  const offers = specification && [
    {
      "@type": "Offer",
      price: specification.price,
      priceCurrency: specification.priceCurrency,
      priceSpecification: specification
    }
  ];
  const aggregateRating = ratingsSummary ? {
    "@type": "AggregateRating",
    ratingValue: ratingsSummary.average,
    reviewCount: ratingsSummary.reviewCount
  } : {};
  const payload = {
    "@type": "Product",
    "@id": `${url}#product`,
    url,
    sku,
    image,
    name: name || sku,
    // 'name' is required in SD, but could be missing and needs a fallback
    ...optionalKey("description", description),
    ...optionalKey("brand", brand),
    ...optionalKey("category", category),
    ...optionalKey("offers", offers),
    ...optionalKey("aggregateRating", aggregateRating),
    ...extra
  };
  return /* @__PURE__ */ React.createElement(JsonLd, { ...payload });
};
export {
  Product
};
//# sourceMappingURL=Product.sd.js.map
